import React, { useEffect, useRef, useState } from "react";
import { View, StyleSheet, ScrollView, KeyboardAvoidingView } from "react-native";
import { Subscription } from "zen-observable-ts";
import { CheckInData, Guestbook, InfoCardTextProps } from "../../../types/types";
import Queries from "../../../api/queries";
import { mobUser } from "../../../mobx/MobUser";
import { ApolloQueryResult } from "@apollo/client";
import GuestbookForm from "./GuestbookForm";
import InfoCard from "../../../components/InfosCard";
import ScrollFAB from "../../../components/FloatingScrollButton";
import HintCard from "./HintCard";
import i18n from "../../../i18n";
import { SafeAreaView } from "react-native-safe-area-context";
import FooterDivider from "../../../components/FooterDivider";

const Invoice = () => {
  const [checkInInfos, setCheckInInfos] = useState<CheckInData>();
  const [guestbookData, setGuestbookData] = useState<InfoCardTextProps[]>();
  const [visibleFAB, setVisibleFAB] = useState(false);
  const [isGuestbookDone, setIsGuestbookDone] = useState(false);
  const queries = new Queries();
  const Scrollref = useRef();

  useEffect(() => {
    let checkInDataSubscription: Subscription;
    let gestbookDataSubscription: Subscription;

    async function subscribeToData() {
      try {
        const checkInObservable = await queries.getCheckIn(mobUser.OiqiaBookingId);
        checkInDataSubscription = checkInObservable.subscribe({
          next(response: ApolloQueryResult<{ NTA_getCheckIn: CheckInData }>) {
            setCheckInInfos(response.data.NTA_getCheckIn);
          },
          error(err) {
            console.error("Error fetching check-in data:", err);
          }
        });
        const guestbookObservable = await queries.getGuestbook(mobUser.OiqiaBookingId);

        gestbookDataSubscription = guestbookObservable.subscribe({
          next(response: ApolloQueryResult<{ getGuestbook: Guestbook[] }>) {
            const newFields = response.data.getGuestbook?.map(guestbookComment => {
              return {
                title: guestbookComment?.firstName + " :",
                text: guestbookComment?.translatedComment?.[mobUser.Language] || guestbookComment?.comment
              };
            }) || [];
            setGuestbookData(newFields);
            setIsGuestbookDone(response.data.getGuestbook.some(field => field.bookingId === mobUser.OiqiaBookingId));
          },
          error(err) {
            console.error("Error fetching check-in data:", err);
          }
        });
      } catch (error) {
        console.error("Error setting up subscription:", error);
      }
    }

    subscribeToData();

    return () => {
      checkInDataSubscription?.unsubscribe();
      gestbookDataSubscription?.unsubscribe();
    };
  }, []);

  const handleScroll = (event) => {
    const { contentOffset, layoutMeasurement, contentSize } = event.nativeEvent;
    const distanceFromBottom = contentSize.height - layoutMeasurement.height - contentOffset.y;
    setVisibleFAB(distanceFromBottom > (layoutMeasurement.height / 2));
  };

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <KeyboardAvoidingView behavior="padding" style={{ flex: 1 }}>
        <ScrollView
          style={styles.container}
          ref={Scrollref}
          onScroll={handleScroll}
          keyboardDismissMode="interactive"
          automaticallyAdjustKeyboardInsets={true}
        >
          <View style={styles.subContainer}>
            <HintCard />
            {guestbookData?.length ?
              guestbookData.map((comment, idx) => {
                return (
                  <InfoCard key={idx} fieldMap={[comment]} />
                );
              })
              : isGuestbookDone ?
                <View style={{ alignItems: "center" }}>
                  <InfoCard fieldMap={[{ text: i18n.t("errors.emptyContent") }]} />
                </View>
                : null
            }
            {!isGuestbookDone && <GuestbookForm checkInInfos={checkInInfos} />}
          </View>
          <FooterDivider />
        </ScrollView>
        {visibleFAB && <ScrollFAB ScrollViewRef={Scrollref} />}
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 0,
  },
  subContainer: {
    width: "80%",
    alignSelf: "center",
    gap: 25,
    marginVertical: 20,
  },
});

export default Invoice;